import LanguageValue from "./LanguageValue";

export default class LanguageValueList {
    constructor(initialList = []) {
        this.list = initialList.map(item => new LanguageValue(item.language, item.value));
      }

    // Add a new language
    add(langObj) {
        if (langObj instanceof LanguageValue) {
            this.list.push(langObj);
        } else {
            throw new Error("Language must be an instance of LanguageValue");
        }
    }

    remove(index) {
        if (index >= 0 && index < this.list.length) {
            this.list.splice(index, 1);
        }
    }

    update(language, value) {
        // Update existing language-value pair
        const pair = this.list.find(item => item.language === language);
        if (pair) {
            pair.value = value;
            // console.log("Update22 existing language-value pair", pair);
        } else {
            this.add(new LanguageValue(language, value)); // If not found, add it
        }
    }

    toJSON() {
        return this.list.map(item => item.toJSON());
    }

    getValues() {
        return this.list;
    }
}